import moment from 'moment'
import React from 'react'
import { check } from '../../../assets/assets'

const CalendarDayOfMonth = ({
  day,
  selectDay,
  selectMonth,
  selectedDay,
  noInstruments,
  noCompletedInstruments,
  noExpiredInstruments,
  instrumentsForDay,
  completedInstrumentsForDay,
  expiredInstrumentsForDay,
  line,
  selectLine,
  selectedLine,
  month
}) => {
  const isActive =
    !!selectedDay && moment(selectedDay).isSame(moment(day), 'day')

  const currentDay = moment(day).clone().locale('en').format('YYYY-MM-DD')
  const isFutureDay = moment(day).isAfter(moment(), 'day')

  // Generic render logic for all dates
  const renderDayCircle = () => {
    try {
      const hasInstruments = Array.isArray(instrumentsForDay) && instrumentsForDay.length > 0
      const hasCompleted = Array.isArray(completedInstrumentsForDay) && completedInstrumentsForDay.length > 0
      const hasExpired = Array.isArray(expiredInstrumentsForDay) && expiredInstrumentsForDay.length > 0

      // Check if any instrument has an instance starting on this specific day
      const hasInstanceStartingToday = hasInstruments && instrumentsForDay.some(instrument => {
        if (!instrument || !Array.isArray(instrument.instances)) return false
        
        return instrument.instances.some(instance => {
          if (!instance || !instance.start_date) return false
          
          const instanceStartDate = moment(instance.start_date)
            .clone()
            .locale('en')
            .format('YYYY-MM-DD')
          return instanceStartDate === currentDay
        })
      })

      // === FUTURE DATES LOGIC ===
      if (isFutureDay) {
        // 🔴 Instance starts today → Big red
        if (hasInstanceStartingToday) {
          return ( <div className='small-circle'>
              <div className='small-circle-inner' />
            </div>)
        }

        // ⚪ No instruments → Small grey
        return <div className='small-grey-circle' />
      }

      // === PAST/TODAY DATES LOGIC ===

      // Pending + completed on the same day (e.g. repeatable persistent instruments)
      if (hasInstruments && hasCompleted) {
        return <div className='big-circle yellow' />
      }

      // Pending only
      if (hasInstruments) {
        return <div className='big-circle red' />
      }

      // Completed only (no pending for this day)
      if (hasCompleted) {
        return (
          <div className='big-circle green'>
            {check()}
          </div>
        )
      }

      // Small red → Only expired
      if (hasExpired) {
        return <div className='small-red-circle' />
      }

      // Small grey → No activity
      return <div className='small-grey-circle' />

    } catch (error) {
      return <div className='small-grey-circle' />
    }
  }

  return (
    <div
      className={`calendar-day-of-month ${isActive ? 'active' : ''}`}
      onClick={() => {
        // Prevent clicks on future dates
        if (isFutureDay) {
          return
        }

        if (isActive) {
          selectDay('')
          selectLine(0)
        } else {
          selectDay(day)
          selectLine(line)
          selectMonth(month)
        }
      }}>
      {renderDayCircle()}
      {moment(day).format('D')}
    </div>
  )
}

export default CalendarDayOfMonth
